<style scoped lang="scss">

</style>

<template>
  <div>
    <Head title="Sector Targets" />
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag='Link' :href="`/sector-targets/${lead.sector_target_id}`">Sector Targets</b-breadcrumb-item>
      <b-breadcrumb-item tag='Link' active>
        {{ contact_name }}
      </b-breadcrumb-item>
    </b-breadcrumb>

    <h3 class="subtitle">{{lead.sector_target.vertical.name}} - {{lead.sector_target.market.label}}</h3>
    <card-component title="Contact">
      <p>
        Name: {{ contact_name }}<br>
        Phone: {{lead.contact.phone }}<br>
        email: {{lead.contact.email }}<br>
        Address: {{full_address}}<br>
      </p>
    </card-component>
    <card-component :title="lead.request_title">
      <div class="bg-white rounded-md shadow overflow-x-auto">
        <div class="bg-white rounded-md shadow overflow-x-auto">
          <h1 class="text-3xl font-bold">
            {{ lead.request_body }}
          </h1>
        </div>
      </div>
    </card-component>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue2'
import Layout from '@/Shared/Layout'
import CardComponent from '@/Shared/CardComponent.vue'
export default {
  components: {
    CardComponent,
    Head,
    Link,
  },
  layout: Layout,
  props: {
    lead: Object,
  },
  data() {
    return {
    }
  },
  computed: {
    contact_name(){
      let contact = this.lead.contact
      return contact.first_name + " " + contact.last_name
    },
    full_address(){
      let contact = this.lead.contact
      return [contact.address, contact.city, contact.region, contact.postal_code].join(', ');
    }
    // full_address() {
    //   let address_lines = (this.business.address2 ?
    //     this.business.address+' '+this.business.address2 : this.business.address );
    //   return [address_lines, this.business.city,
    //     this.business.state, this.business.postal_code].join(', ');
    // }
  },
  methods: {
  }
}
</script>
